import React from 'react'
import { ContentfulPageBanner as ContentfulPageBannerType } from '@reward-platform/contentful'
import { ButtonGroup, CardSection, Eyebrow, Heading } from '@alto-avios/alto-ui'
import { deviceSizes } from '~/styles/deviceSizes'
import { getContentfulImageProps } from '~/utils/assets'
import { RichText } from './ContentfulRichText'
import ContentfulCta from './ContentfulCta'
import { ContentfulImage, ImageSize } from '../shared/ContentfulImage'

const imageSizes: ImageSize[] = [
  {
    width: 300,
    height: 200,
    media: `(max-width: ${deviceSizes.sm})`,
    densities: [1, 2],
  },
  {
    width: 400,
    height: 250,
    media: `(max-width: ${deviceSizes.md})`,
    densities: [1, 2],
  },
  {
    width: 600,
    height: 600,
    media: `(min-width: ${deviceSizes.md})`,
    densities: [1, 2],
  },
]

const ContentfulPageBanner = ({
  identifier,
  heading,
  bodyCopy,
  imagePosition,
  image,
  bynderImage,
  badge,
  ctaPrimary,
  ctaSecondary,
  variant,
  entryId,
  revisionId,
}: ContentfulPageBannerType) => {
  const eventData = {
    sectionId: identifier ?? 'page banner',
    sectionHeading: heading || 'page banner',
    contentfulEntryId: entryId,
    contentfulRevisionId: revisionId,
  }
  const { imgSrc, imgAlt, imgContentType, imgFormat } = getContentfulImageProps({
    bynderImage,
    image,
    fallbackAlt: heading,
  })

  return (
    <CardSection isReversed={imagePosition === 'left'}>
      <CardSection.Content>
        {badge ? <Eyebrow>{badge?.label}</Eyebrow> : null}
        <Heading as="h2" foregroundColor="accentSecondary" size="lg" textAlign="start">
          {heading}
        </Heading>
        {bodyCopy ? <RichText document={bodyCopy} sizes={{ p: 'lg' }} /> : null}
        {ctaPrimary || ctaSecondary ? (
          <ButtonGroup>
            {ctaPrimary ? (
              <ContentfulCta {...ctaPrimary} variant="primary" eventData={eventData} />
            ) : null}
            {ctaSecondary ? (
              <ContentfulCta {...ctaSecondary} variant="secondary" eventData={eventData} />
            ) : null}
          </ButtonGroup>
        ) : null}
      </CardSection.Content>
      {imgSrc ? (
        <CardSection.Media>
          <ContentfulImage
            src={imgSrc}
            alt={imgAlt}
            sizes={imageSizes}
            format={imgFormat}
            contentType={imgContentType}
          />
        </CardSection.Media>
      ) : null}
    </CardSection>
  )
}

export default ContentfulPageBanner
